// extracted by mini-css-extract-plugin
export var createdDate = "_ln-1";
export var divider = "_ln-2";
export var headerDivider = "_ln-3";
export var messagesCard = "_ln-0";
export var messagesContainer = "_ln-7";
export var messagesContainerWrapper = "_ln-4";
export var pointerCapturingButtonBoxes = "_ln-a";
export var showLeftPanelButton = "_ln-9";
export var showMoreButton = "_ln-c";
export var showMoreButtonContainer = "_ln-b";
export var summaryTitle = "_ln-6";
export var systemMessageCardWrapper = "_ln-d";
export var topButtons = "_ln-8";
export var withPadding = "_ln-5";